'use strict';

module.exports = textFilter;
/*@ngInject*/
function textFilter($sce) {
    var urls = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
    var emails = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    var breakTag = '<br>';
    return function (text) {
        if (!text) {
            return '';
        }
        if (text.match(urls)) {
            text = text.replace(urls, "<a href=\"$1\" target=\"_blank\">$1</a>");
        }
        if (text.match(emails)) {
            text = text.replace(emails, "<a href=\"mailto:$1\">$1</a>");
        }

        text = text.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');

        return $sce.trustAsHtml(text);
    };
}


/** WEBPACK FOOTER **
 ** ./app/shared/filters/text.filter.js
 **/